var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v-header"},[_c('img',{staticStyle:{"height":"36px"},attrs:{"src":_vm.logo}})])
}
var staticRenderFns = []

export { render, staticRenderFns }